import type { UserAppType } from '../enums/UserAppType'
import type { CustomMessageShowType } from '../enums/CustomMessageShowType'
import type { Language } from '@/shared/enums/languagesEnum'

export class CustomMessageMiniEntity {
     id?: number;
    showType?: CustomMessageShowType;
    imageUrl?: string | null;
    title?: string | null;
    description?: string | null;
    isEnabled?: boolean;
    startDate?: string;
    expirationDate?: string | null;
    languages?: Array<Language> | null;
    userAppTypes?: Array<UserAppType> | null;
}
